// extracted by mini-css-extract-plugin
module.exports = {"card":"Payout_card__1DPbc"};